import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach token fallback (works if cookies are lost on mobile Safari)
export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    try { localStorage.setItem("fci_token", token); } catch {}
  } else {
    delete api.defaults.headers.common["Authorization"];
    try { localStorage.removeItem("fci_token"); } catch {}
  }
}

// Init from localStorage on load
try {
  const saved = localStorage.getItem("fci_token");
  if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;
} catch {}

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatFCFA(n) {
  if (n == null) return "";
  return new Intl.NumberFormat("fr-FR").format(n) + " FCFA";
}

export async function fileToBase64(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

/**
 * Resolve a stored media reference into a full src URL usable by <img> /
 * <video>. Handles three formats coexisting in the DB during the migration:
 *   - "/api/files/..."  → prepend BACKEND_URL
 *   - "data:image/..."  → legacy base64, return as-is
 *   - "http(s)://..."   → external URL (e.g. ad creatives), return as-is
 *   - falsy             → return as-is so consumers can early-return
 */
export function mediaSrc(ref) {
  if (!ref) return ref;
  if (typeof ref !== "string") return ref;
  if (ref.startsWith("/api/")) return `${BACKEND_URL}${ref}`;
  return ref;
}

/**
 * Upload a single file to Emergent Object Storage via the backend and return
 * the relative URL (e.g. "/api/files/forum-ci/...") that should be stored in
 * the shop / product / ad payload.
 *
 * `kind` must be one of: shop_cover | shop_profile | product_image |
 * product_video | ad_image — see backend/routers/uploads.py ALLOWED_KINDS.
 */
export async function uploadFile(file, kind) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post(`/uploads?kind=${encodeURIComponent(kind)}`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url; // "/api/files/<path>"
}
